import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Government } from './government';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class GovernmentService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Government[]> {
    return this.httpClient.get<Government[]>(this.baseUrl + '/api/GovernmentApi')
  }
  Post(government: Government): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + '/api/GovernmentApi/add', government, { headers: header, observe: 'response' })
  }
  Delete(government: Government) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + '/api/GovernmentApi/activeordeactive', government, { headers: header, observe: 'response' })
  }
  Put(government: Government): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + '/api/GovernmentApi/Update', government, { headers: header, observe: 'response' })
  }


}
